import { useDraggable } from "@dnd-kit/react"
import type { ReactNode } from "react"

type Props = {
    id: number,
    children: ReactNode
    className?: string
    onClick?: () => void
}

export default function CardDraggable({id, children, className, onClick} : Props) {
    
    const {ref} = useDraggable({id: id})
    
    
    return (
    <div ref={ref} className={className} onClick={onClick}>
      {children}
    </div>
  )
}
